import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, OnChanges, Output, SimpleChanges } from '@angular/core';
import { DisplayMapStoreMunicipality } from '@app/shared/models/municipality/Municipality';
import { AuthService } from '@app/shared/services/auth.service';
import { OverlayLoaderService } from '@app/shared/services/overlay-loader.service';
import { DialogStateService } from '@app/shared/services/state/dialog-state.service';
import { UserMunicipalitiesService } from '@app/shared/services/user-municipalities.service';
import { isNil } from 'lodash';

export interface SelectFieldConfig {
  municipalityFieldPlaceholder: string;
  searchFieldPlaceholder: string;
  floatLabel?: string;
  appearance?: string;
}
@Component({
  selector: 'app-multipurpose-dropdown',
  templateUrl: './multipurpose-dropdown.component.html',
  styleUrls: ['./multipurpose-dropdown.component.scss'],
})
export class MultipurposeDropdownComponent implements OnInit, OnChanges {
  @Input() municipalities: DisplayMapStoreMunicipality[] = [];
  @Input() displaySearch = true;
  @Input() selectedMunicipality = '';
  @Input() shouldShowSpinner: boolean = true;
  @Input() showCheckBox = false;
  @Input() dropdownFieldConfig: SelectFieldConfig = {
    municipalityFieldPlaceholder: '',
    searchFieldPlaceholder: 'Gemeindesuche',
    floatLabel: 'auto',
  };

  @Output() adminAreaRegionChange = new EventEmitter();
  @Output() municipalityChange = new EventEmitter();
  @Output() dropdownToggle = new EventEmitter<boolean>();
  showDropdown = false;
  selectedToggleOption = 'municipality';

  constructor(
    private _elementRef: ElementRef,
    public authService: AuthService,
    public overlayLoaderService: OverlayLoaderService,
    public userMunicipalitiesService: UserMunicipalitiesService,
    private readonly dialogState: DialogStateService,
  ) {}

  ngOnInit(): void {
    if (!isNil(localStorage.getItem('currentMunicipality'))) {
      const storedMunicipality = this.municipalities.find((a: any) => a.name === localStorage.getItem('currentMunicipality'));
      storedMunicipality ? this.userMunicipalitiesService.updateMunicipality(storedMunicipality) : '';
      localStorage.removeItem('currentMunicipality');
    }
  }

  @HostListener('document:click', ['$event']) checkExternalClick($event: Event) {
    if (this.dialogState.isOpen) return;
    if (this.dialogState.consumeIgnoreNextOutsideClick()) {
      return; // skip exactly one click
    }

    if (!this._elementRef.nativeElement.contains($event.target)) {
      this.showDropdown = false;
      this.dropdownToggle.emit(this.showDropdown);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['municipalities']) {
      const municipalitySelected = this.userMunicipalitiesService.currentMunicipality;
      const currSelected = this.municipalities.find((a: any) => a.key === municipalitySelected.key) ?? '';
      currSelected
        ? (this.selectedMunicipality = this.authService.isMunicipalityWorker ? `${currSelected.name}` : `${currSelected.name} (${currSelected.key})`)
        : (this.selectedMunicipality = currSelected);
      this.adminAreaRegionChange.emit();
    }
    this.overlayLoaderService.isLoading = this.shouldShowSpinner;
  }

  toggleDropdown() {
    this.showDropdown = !this.showDropdown;
    this.dropdownToggle.emit(this.showDropdown);
  }

  selectMunicipality(municipality: string | DisplayMapStoreMunicipality) {
    this.showDropdown = false;
    if (this.selectedMunicipality !== municipality) {
      this.municipalityChange.emit(municipality);
    }
  }

  selectedMunicipalities(municipality: string): void {
    this.selectedMunicipality = municipality;
  }
}
